<template>
  <div class="PortfolioSwitcher">
    <div class="PortfolioSwitcher__multiselect">
      <PortfolioSelect
        :value="selection"
        v-bind="$props"
        @input="select"
        :excluded="portfolios"
      />
    </div>
    <ul class="PortfolioSwitcher__list">
      <li v-for="portfolio in portfolios" :key="portfolio.uid" class="PortfolioSwitcher__item">
        <a
          class="PortfolioSwitcher__link"
          :title="portfolio.name"
          @click="$auth.setCurrentPortfolio(portfolio)"
        >{{ portfolio.name | truncate(60) }}
        </a>
        <span v-if="portfolio.uid !== $auth.user.currentPortfolio.uid" @click.stop="$emit('removePortfolio', portfolio)" class="PortfolioSwitcher__delete">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="#9BB1B7"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import truncate from "@synbioz/truncate";
import { PortfolioSelect } from "@delegate/auth-api-client";

export default {
  props: {
    portfolios: {
      type: Array,
      default: () => []
    },
    switcher: {
      type: Object,
      default: () => ({})
    },
    authHost: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      options: [],
      selection: null
    };
  },
  methods: {
    select(portfolio) {
      this.selection = null;
      this.$emit("addPortfolio", portfolio);
    }
  },
  filters: { truncate },
  components: { PortfolioSelect }
};
</script>
<style src="../assets/stylesheets/_portfolio-switcher.scss" lang="scss"></style>
